import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    messages: {},
    currentStep: "1",
    msisdn: "",
    email: "",
    token: "",
    showLoader: 0,
    applicationName: "etopupAF2G",
    userProfileAndTariffsObject:{},
    cardAndRecurringInfoObject:{},
    guid: "unknown",
    taxNumber: "unknownTaxNumber",
    customerCode: "unknownCustomerCode",
    customerName: "unknownCustomerName",
    hostName: "212.205.16.1",
    urlParamMsisdn: "",
    urlParamAmount: "",
    urlParamTransactionCode: "",
    activeFlow: true,
    showSuccessComponent: false,
    showErrorComponent: false,
    showWarningModal: false,
    forcePersonalDataMessage: "",
    forcePersonalDataErrorMessage: "",
    faultDescription: "",
    showSavedCardComponent: false,
    amount: "",
    locale: "",
    loginInfo: "",
    errorFromBank: false
  },
  mutations: {
    translations (state, payload) {
      state.messages = payload;
    },
    changeStep (state, payload) {
        state.currentStep = payload;
    },
    setMsisdn (state, payload) {
        state.msisdn = payload;
    },
    setEmail (state, payload) {
        state.email = payload;
    },
    setToken (state, payload) {
        state.token = payload;
    },
    showLoader(state){
      state.showLoader =1 ;
    },
    hideLoader(state){
      state.showLoader =0;
    },
    setUserProfileAndTariffs(state, data){
      state.userProfileAndTariffsObject = data;
    },
    setCardAndRecurringInfo(state, data){
      state.cardAndRecurringInfoObject = data;
      state.cardList = data.cardList;
      // if (data.cardList.length > 0){
      //   state.cardBrand = data.cardList[0].brand;
      //   state.cardPan = data.cardList[0].pan;
      //   state.expiryDate = data.cardList[0].expiryDate; 
      // }
    },
    setUrlParamMsisdn(state, data){
      state.urlParamMsisdn = data ;
    },
    setUrlParamAmount(state,data){
      state.urlParamAmount = data;
    },
    setUrlParamTransactionCode(state,data){
      state.urlParamTransactionCode = data;
    },
    setActiveFlow(state, data){
      state.activeFlow = data;
    },
    showSuccessComponent(state, data){
      state.showSuccessComponent = data;
    },
    showErrorComponent(state, data){
      state.showErrorComponent = data;
    },
    showWarningModal(state, data){
      state.showWarningModal = data;
    },
    forcePersonalDataErrorMessage(state, data){
      state.forcePersonalDataErrorMessage = data;
    },
    forcePersonalDataMessage(state, data){
      state.forcePersonalDataMessage = data;
    },
    setFaultDescription(state, data){
      state.faultDescription = data;
    },
    showSavedCardComponent(state, data){
      state.showSavedCardComponent = data;
    },
    setAmount(state, data){
      state.amount = data;
    },
    setLocale(state, data) {
      state.locale = data;
    },
    setLoginInfo(state, data) {
      state.loginInfo = data;
    },
    setErrorFromBank(state, data) {
      state.errorFromBank = data;
    },
  },
  strict: true
})